module.exports = __webpack_public_path__ + "img/poster.f2c98370.jpeg";